module.exports = __webpack_public_path__ + "static/img/tagheuer_logo_1.3a48fd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tagheuer_logo_1.png
// module id = ClOq
// module chunks = 1